import guard from "./auth-guard";
import Router from "./router";

Router.beforeEach(guard);

export default Router;
